import { Box, SpaceVertical, TextArea } from '@looker/components';
import { globalTheme } from '@pulsepointinc/bi-components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import styled from 'styled-components';

export const ExpandableNotificationContainer = styled(Box)`
  border: 1px solid ${globalTheme.colors.warning};
  border-radius: 4px;
  color: ${globalTheme.colors.warning};
  width: 100%;
`;

export const ScrollableList = styled(Box)`
  max-height: 180px;
  overflow-y: auto;
  padding: 0 12px 12px 40px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${globalTheme.colors.warning};
    border-radius: 10px;
  }
`;

export const StyledTextArea = styled(TextArea)`
  width: 100%;  
  height: 100%;
  min-height: 300px;
`;

export const StyledDropzone = styled(SpaceVertical)<{ isDragging: boolean }>`
  border: 1px dashed ${({ isDragging }) => (isDragging ? globalTheme.colors.primaryNew : globalTheme.colors.outlineLight)};
  background-color: ${({ isDragging }) => (isDragging ? globalTheme.colors.primary200 : 'white')};
  align-items: center;
  justify-content: center;
  padding: 24px;
  border-radius: 12px;
  gap:4px;
  cursor: pointer;
  position: relative;

  :hover {
    border-color: ${globalTheme.colors.primaryNew};
  }

  & > * {
    pointer-events: none;
  }
`;

export const BrowseLabel = styled(DsTypography)`
  padding-left: 4px;
`;
